import { Label } from '@cian/ui-kit';

import { mapLabelBgColor, mapLabelColor } from './mapColors';
import { mapLabelIcon } from './mapIcons';
import { mapLabelTextToTestId } from './mapTestId';
import * as styles from './styles.css';
import { ILabel } from '../../types/label';
import { GeneralInfoSectionRow } from '../GeneralInfoSectionRow';
import { LabelTooltip } from './components';

interface ILabelsListProps {
  labels: ILabel[];
}

export function LabelsList({ labels }: ILabelsListProps) {
  return (
    <GeneralInfoSectionRow>
      <div className={styles['container']} onClick={e => e.stopPropagation()} data-name="LabelsList">
        {labels.map((label, idx) => (
          <div className={styles['label']} key={idx}>
            <LabelTooltip tooltip={label.tooltip}>
              <Label
                background={mapLabelBgColor(label.color)}
                color={mapLabelColor(label.color)}
                icon={mapLabelIcon(label.color)}
                data-testid={mapLabelTextToTestId(label.text)}
              >
                {label.text}
              </Label>
            </LabelTooltip>
          </div>
        ))}
      </div>
    </GeneralInfoSectionRow>
  );
}
